var _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", {
    style: {
      stroke: "none",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "translate(1.4065934065934016 1.4065934065934016) scale(2.81 2.81)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 45 72.864 C 44.999 72.864 45 72.864 45 72.864 c -14.889 0 -29.874 -8.944 -44.538 -26.586 c -0.616 -0.741 -0.616 -1.816 0 -2.557 C 15.126 26.08 30.111 17.135 45 17.135 c 14.889 0 29.874 8.945 44.539 26.586 c 0.616 0.741 0.616 1.816 0 2.557 C 74.874 63.919 59.888 72.864 45 72.864 z M 4.615 45 C 18.128 60.837 31.709 68.864 45 68.864 S 71.872 60.837 85.386 45 C 71.872 29.163 58.29 21.135 45 21.135 S 18.128 29.163 4.615 45 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 45 64.103 c -10.533 0 -19.102 -8.569 -19.102 -19.103 c 0 -10.533 8.569 -19.102 19.102 -19.102 c 10.533 0 19.103 8.569 19.103 19.102 C 64.103 55.533 55.533 64.103 45 64.103 z M 45 29.898 c -8.327 0 -15.102 6.775 -15.102 15.102 S 36.673 60.103 45 60.103 S 60.103 53.327 60.103 45 S 53.327 29.898 45 29.898 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.3d0a20ab9f5d23aea06b3114e7237103.svg";
export { ForwardRef as ReactComponent };